// eslint-disable-next-line prettier/prettier
import axios from 'axios'


export const sendServerEvent = async (eventData) => {
  
  const priceInfo = separateCurrencyAndValue(eventData.price)

  window.fbq('track', 'Purchase',
    {
      value: priceInfo.value,
      currency: priceInfo.currency,
      contents: [
        {
          event_time: Math.floor(Date.now() / 1000),
          em: [await hashEmail(eventData.email)],
          event_id: eventData.eventId,
          action_source: 'website',
        },
      ],
      content_type: 'product',
    }
  )
}

const hashEmail = async (email) => {
  const encoder = new TextEncoder()
  const data = encoder.encode(email)
  const hashBuffer = await crypto.subtle.digest('SHA-256', data)
  const hashArray = Array.from(new Uint8Array(hashBuffer))
  const hashHex = hashArray.map(b => b.toString(16).padStart(2, '0')).join('')

  return hashHex
}

const separateCurrencyAndValue = (price) => {
  const regex = /^([a-zA-Z]+)\s(\d+(\.\d+)?)/
  const match = price.match(regex)

  if(!match) {
    return null
  }

  return {
    currency: match[1],
    value: parseFloat(match[2]),
  }
}
